import React from "react";
import SectionBoundary from "./SectionBoundary";
import Reveal from "./Reveal";
import {backgroundOf} from "./backgrounds";
import {BLOCK_COMPONENTS} from "./blocks";
import {hasOwn} from "./pageModel";

const ANIMATIONS = ["none", "fade", "slide"];

// Rubrique libre : réglages (fond, colonnes, alignement, animation) + blocs. Chaque bloc est isolé : un bloc inconnu est
// ignoré, un bloc qui plante disparaît seul. Les couleurs viennent des classes .custom-bg--<id> de LandingPage.css.
export default function CustomSection({section, ctx}) {
    const settings = section.settings || {};
    const background = backgroundOf(settings.background);
    const columns = settings.columns === "2" ? "2" : "1";
    const align = settings.align === "center" ? "center" : "left";
    const animation = ANIMATIONS.includes(settings.animation) ? settings.animation : "fade";
    const blocks = Array.isArray(section.blocks) ? section.blocks.filter(b => b && hasOwn(BLOCK_COMPONENTS, b.type)) : [];

    const className = [
        "custom-section", `custom-bg--${background.id}`, `custom-section--cols-${columns}`, `custom-section--${align}`,
        background.dark ? "custom-section--dark" : "",
    ].filter(Boolean).join(" ");

    return (
        <section className={className} id={section.id}>
            <div className="wrap custom-section__inner">
                {blocks.map(block => {
                    const Component = BLOCK_COMPONENTS[block.type];
                    return (
                        <Reveal key={block.id} animation={animation}>
                            <SectionBoundary name={block.type}>
                                <Component data={block.data || {}} ctx={ctx}/>
                            </SectionBoundary>
                        </Reveal>
                    );
                })}
            </div>
        </section>
    );
}
